import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../util/utils';
import Modal from '../../../../Common/Modal/Modal';
import EllipsesControl from '../../../EllipsesControl/EllipsesControl';
import TextAreaEditorWrapper from '../../../../Common/TextAreaEditor/TextAreaEditor';
import {dropdownActions} from '../../../../../actions/RiskFactor/riskfactoractions';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';

function RiskFactorDescriptionModal({value, mode, onSave, onCancel, onHide}) {
	const [description, setDescription] = useState(value);
	const [showError, setShowError] = useState(false);
	const [isSaving, setIsSaving] = useState(false);

	const descriptionIsValid = () => {
		return description?.length > 0;
	};

	const handleOnSave = () => {
		if (descriptionIsValid()) {
			setShowError(false);
			setIsSaving(true);
			onSave(description.trim())
				.then(() => {
					onHide();
				})
				.catch(() => {
					onCancel && onCancel();
				})
				.finally(() => {
					setIsSaving(false);
				});
		} else {
			setShowError(true);
		}
	};

	const errorMessage = (
		<EllipsesControl
			content={labels.riskFactorDescriptionRequired}
			tooltip={labels.riskFactorDescriptionRequired}
			noOfLines={1}
		/>
	);

	return (
		<StyledRiskFactorDescriptionModal className="StyledRiskFactorDescriptionModal">
			<Modal
				title={mode === dropdownActions.edit ? labels.editRiskFactorDescription : labels.addNewDescription}
				onOkClick={handleOnSave}
				onHide={() => {
					onCancel && onCancel();
					onHide();
				}}
				modalsize="small"
				closeBtnTitle={labels.modalCancelTitle}
				confirmBtnTitle={labels.saveLabel}
				closeTitle={labels.modalCloseTitle}
				isOkButtonDisabled={isSaving}
				isCancelButtonDisabled={isSaving}
				show
				showButtons
				modalContainerClass="RiskFactorDescriptionModalContainer"
				modalbodystyle="RiskFactorDescriptionModalBody"
				isAresView
			>
				<StyledBody className={`RiskFactorDescriptionModalStyledBody ${isSaving ? 'SavingOn' : ''}`}>
					{/* <LoadingIndicator show={isSaving} view={"fullView"} /> */}
					{isSaving && (
						<section className="MotifProgressBarWrapper">
							<ProgressBar isIndeterminate circle hideLabel />
						</section>
					)}
					<TextAreaEditorWrapper
						textAreaError={!descriptionIsValid() && showError}
						textAreaErrorMessage={errorMessage}
						textAreaEditorLabel={labels.enterRiskFactorDescription}
						placeholder={''}
						value={description}
						showCounter={true}
						maxLength={500}
						onChange={(e) => setDescription(e.target.value)}
						isDisabled={isSaving}
						focusOnRender
					/>
				</StyledBody>
			</Modal>
		</StyledRiskFactorDescriptionModal>
	);
}

export default RiskFactorDescriptionModal;
RiskFactorDescriptionModal.propTypes = {
	onSave: PropTypes.func,
	onCancel: PropTypes.func,
	hideModal: PropTypes.func
};

const StyledRiskFactorDescriptionModal = styled.section``;

const StyledBody = styled.section`
	position: relative;
	.MotifProgressBarWrapper {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
		background: transparent !important;
		.motif-progress-bar-wrapper {
			display: flex !important;
			background-color: transparent !important;
		}
		.motif-progress-bar-wrapper-circle {
			height: 100% !important;
			width: 100% !important;
		}
	}
	.motif-text-area {
		min-height: var(--px-150) !important;
	}
	.motif-loader-container {
		z-index: 9;
	}
`;
